export default __webpack_public_path__ + "static/googleOptimize-6a145aab89f46451e88ed3bbe6736021.png";